import { TaxoStage } from '@/kontent/taxonomies/stage'
import { TaxoStageGroup } from '@/kontent/taxonomies/stage_group'
import { mapTreeElementToTreeNode } from '@/layouts/wp_dc_recentchanges'
import { makeStageGroupOptions } from '@/layouts/wp_teachingadvice'
import { ElementModels } from '@kontent-ai/delivery-sdk'
import { useMemo } from 'react'
import { TreeNodeProps } from 'react-dropdown-tree-select'

export const useStageTreeNodeProps = ({
	stageGroups,
	stages,
	selectedStages,
	withLifeSkillsOnSecondaryAndSenior = false,
	hideStageGroupsInStageFilter = false,
}: {
	stageGroups: ElementModels.TaxonomyTerm<TaxoStageGroup>[]
	stages: ElementModels.TaxonomyTerm<TaxoStage>[]
	selectedStages: TaxoStage[]
	withLifeSkillsOnSecondaryAndSenior?: boolean
	hideStageGroupsInStageFilter?: boolean
}) =>
	useMemo<TreeNodeProps[]>(() => {
		if (hideStageGroupsInStageFilter) {
			// if stages include stage_4 and stage_5, then add life_skills to the list
			const isLifeSkillSecondary = stages.some((stage) => {
				return (
					stage.codename === 'stage_4' || stage.codename === 'stage_5'
				)
			})
			const isLifeSkillSenior = stages.some((stage) => {
				return stage.codename === 'stage_6'
			})

			let lifeSkillsValue = isLifeSkillSecondary
				? 'life_skills@stage_4___stage_5'
				: isLifeSkillSenior
				? 'life_skills@stage_6'
				: null

			return [
				...stages.map((stage) => {
					return {
						value: stage.codename,
						label: stage.name,
						checked: selectedStages.includes(stage.codename),
						children: [],
					}
				}),
				lifeSkillsValue
					? {
							label: 'Life Skills',
							value: lifeSkillsValue,
							checked: selectedStages.includes(
								lifeSkillsValue as unknown as TaxoStage,
							),
							children: [],
					  }
					: null,
			].filter(Boolean)
		}
		return makeStageGroupOptions(
			stageGroups,
			stages,
			withLifeSkillsOnSecondaryAndSenior,
		).map((treeElement) =>
			mapTreeElementToTreeNode(treeElement, selectedStages),
		)
	}, [
		stageGroups,
		stages,
		selectedStages,
		withLifeSkillsOnSecondaryAndSenior,
	])
